import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { IStatusPanelParams } from "ag-grid-community";

interface Props extends IStatusPanelParams {
	onNewProduct: () => void;
}

export const NewProductStatusBar = ({ onNewProduct }: Props) => {
	return (
		<Button
			variant="contained"
			color="primary"
			size="small"
			startIcon={<AddIcon />}
			onClick={onNewProduct}
			sx={{
				textTransform: "none",
				margin: "4px 8px",
			}}
		>
			NEW PRODUCT
		</Button>
	);
};
